import { destroyCookie, parseCookies } from 'nookies';

export const AUTH_COOKIE_NAME = 'api_backend_token_spacetalk';

export const destroyAuthCookie = (): void => {
  try {
    destroyCookie(null, AUTH_COOKIE_NAME, { path: '/' });
  } catch (error) {
    console.error('Failed to destroy auth cookie:', error);
    // Don't throw here as this is often called during cleanup
  }
};

// Remove legacy/client-side cookies that can confuse auth state.
// We intentionally preserve language cookies and the auth cookie.
export const cleanupNonEssentialCookies = (): void => {
  try {
    const all = parseCookies(null);
    // Only keep essential cookies
    const allowList = new Set<string>([AUTH_COOKIE_NAME, 'NEXT_LOCALE', 'lang']);

    Object.keys(all).forEach(name => {
      if (!allowList.has(name)) {
        try {
          destroyCookie(null, name, { path: '/' });
        } catch {
          // ignore individual failures
        }
      }
    });
  } catch (error) {
    console.error('Failed to cleanup non-essential cookies:', error);
  }
};
